import {Button, Typography} from '@mui/material';
import {IconIllustration, StyledCard} from 'presentation/components';
import {ChatRoomsEnum} from 'presentation/constants';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText, getOnlyFirstWord} from 'presentation/utils';
import React from 'react';
import {StyledHeader} from './styles';

const {suspendedCard} = translations['pt-br'].privateFlow.home;
const {regularizeNow} = translations['pt-br'].commons;

function SuspendedCard() {
	const {callChatRoom} = useCallChatRoom();
	const {
		beneficiary: {nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(store => store.accountData);
	const formattedBeneficiary = getOnlyFirstWord(formatText(nmSocialUsuarioC || nmUsuarioC));

	return (
		<StyledCard.Container
			sx={{
				display: 'flex',
				alignItems: 'start',
				gap: '12px',
			}}>
			<StyledHeader>
				<Typography variant="body2" component={'span'} color="text.primary">
					{formattedBeneficiary}
					{suspendedCard.line1}
				</Typography>
				<IconIllustration variant="warning" size="small" />
			</StyledHeader>

			<Button
				variant="outlined"
				fullWidth
				onClick={() => callChatRoom(ChatRoomsEnum.DEBIT_NEGOTIATION)}>
				{regularizeNow}
			</Button>
		</StyledCard.Container>
	);
}

export default SuspendedCard;
